import { useState } from 'react'

function Sidebar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <>
      <button
        className="fixed top-4 left-4 z-50 p-2 bg-gray-800 rounded-md"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          {isMenuOpen ? (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          ) : (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          )}
        </svg>
      </button>

      {isMenuOpen && (
        <nav className="fixed top-0 left-0 h-full w-64 bg-gray-900 text-white z-40 flex flex-col py-10 px-6 border-r border-gray-800">
          <h1 className="text-2xl font-bold my-10">TB. Bumi Serpong</h1>
          <a href="#hero" className="text-gray-300 hover:text-blue-400 mb-4" onClick={() => setIsMenuOpen(false)}>Home</a>
          <a href="#maps" className="text-gray-300 hover:text-blue-400 mb-4" onClick={() => setIsMenuOpen(false)}>Location</a>
          <a href="#contact" className="text-gray-300 hover:text-blue-400 mb-4" onClick={() => setIsMenuOpen(false)}>Contact</a>
        </nav>
      )}
    </>
  )
}

export default Sidebar
